import { Action } from '@ngrx/store';

export enum EstablishmentActionTypes {
  LOAD_ESTABLISHMENT = '[Establishment] Load Establishment',
  LOAD_ESTABLISHMENT_SUCCESS = '[Establishment] Load Establishment Success',
  LOAD_ESTABLISHMENT_FAILURE = '[Establishment] Load Establishment Failure',
  LOAD_ESTABLISHMENT_CLEAR = '[Establishment] Load Establishment Clear',
}

export class LoadEstablishment implements Action {
  readonly type = EstablishmentActionTypes.LOAD_ESTABLISHMENT;
}

export class LoadEstablishmentSuccess implements Action {
  readonly type = EstablishmentActionTypes.LOAD_ESTABLISHMENT_SUCCESS;
  constructor(public payload: RascunhoAnaliseResponseRecord) {}
}

export class LoadEstablishmentFailure implements Action {
  readonly type = EstablishmentActionTypes.LOAD_ESTABLISHMENT_FAILURE;
  constructor(public payload: { error: boolean }) {}
}
export class LoadEstablishmentClear implements Action {
  readonly type = EstablishmentActionTypes.LOAD_ESTABLISHMENT_CLEAR;
  constructor() {}
}

export type EstablishmentActions =
  | LoadEstablishment
  | LoadEstablishmentSuccess
  | LoadEstablishmentClear
  | LoadEstablishmentFailure;
